/* istanbul ignore file */

import { Temporal } from '@js-temporal/polyfill';
import { Page } from '@playwright/test';

type FakeTimeProps = {
  page: Page;
  date: Temporal.PlainDate | Temporal.PlainDateTime | Temporal.Instant;
};

export const fakeTime = async (props: FakeTimeProps) => {
  const { page, date } = props;
  let fakeNow;

  if (date instanceof Temporal.PlainDate || date instanceof Temporal.PlainDateTime) {
    fakeNow = Temporal.Instant.from(date.toZonedDateTime('UTC').toString()).epochMilliseconds;
  } else {
    fakeNow = date.epochMilliseconds;
  }

  await page.addInitScript(`{
    // Extend Date constructor to default to fakeNow
    Date = class extends Date {
      constructor(...args) {
        if (args.length === 0) {
          super(${fakeNow});
        } else {
          super(...args);
        }
      }
    }
    // Override Date.now() to start from fakeNow
    const __DateNowOffset = ${fakeNow} - Date.now();
    const __DateNow = Date.now;
    Date.now = () => __DateNow() + __DateNowOffset;
  }`);
};
